import React, { useEffect, useState } from "react"
import StorageService from "../../../App/StorageService"
import { StorageKey } from "../../../App/enums"
import "../../../Styles/main.scss"

function Image(props: React.ImgHTMLAttributes<HTMLImageElement>) {
    const imageProps: React.ImgHTMLAttributes<HTMLImageElement> = React.useMemo(() => ({
        ...props,
    }), [props]);
    const [isVisible,setIsVisible] = useState(false)
    const [imageSrc, setImageSrc] = useState('')

    const accessToken = StorageService.getItem(StorageKey.accessToken) as string

    const addCacheItem = (key: string, value: string, ttl: number) => {
        const expiry = Date.now() + ttl;
        const item = { value, expiry };
        try {
            sessionStorage.setItem(key, JSON.stringify(item));
        } catch (e) {
            // Item too large or storage quota exceeded
        }
    };

    const getCacheItem = (key:string) => {
        const itemStr = sessionStorage.getItem(key)
        if (!itemStr) {
            return null
        }
        const item = JSON.parse(itemStr)
        const now = new Date()
        if (now.getTime() > item.expiry) {
            sessionStorage.removeItem(key)
            return null
        }
        return item.value
    }
    

    const getBase64Image = async (res: Response): Promise<string | ArrayBuffer | null> => {
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    useEffect(() => {
        let src = imageProps.src ?? "";
        // Normalize dev URLs
        if (src.includes("3000")) {
            src = src.replace("3000", "8000").replace("https://", "http://");
        }

        // Check if image needs to be fetched with auth
        const isMedia =
            src.startsWith("/media") ||
            src.includes(process.env.REACT_APP_BASE_API_URL!.replace("api", ""));

        if (isMedia) {
            const split = src.split("/");
            const filename = split[split.length - 1];

            const cachedItem = getCacheItem(filename);
            if (cachedItem) {
                setImageSrc(cachedItem);
                setIsVisible(true);
                return;
            }

            // Ensure absolute URL for localhost
            if (
                window.location.hostname === "localhost" &&
                src.startsWith("/media")
            ) {
                src = process.env.REACT_APP_BASE_API_URL!.replace("api", "") + src;
            }

            src = src.replace("//media", "/media");

            fetch(src, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => getBase64Image(res))
                .then((imgString) => {
                    if (imgString) {
                        setImageSrc(imgString as string);
                        setIsVisible(true);
                        addCacheItem(filename, imgString as string, 3600000);
                    }
                })
                .catch(() => {
                    setIsVisible(true);
                    setImageSrc("");
                });
        } else {
            setIsVisible(true);
            setImageSrc(src);
        }
    }, [accessToken, imageProps.src]);


    return <img {...imageProps} style={{display: isVisible ? 'block' : 'none'}} alt='' src={imageSrc}></img>
}
export default Image
